import { useQuery } from '@tanstack/react-query';
import { supabase } from '../utils/supabaseClient';
import { queryKeys } from '../utils/queryKeys';
import { useQueryError } from './useQueryError';

export function useVideoPreview(companyId, size) {
  const { handleError } = useQueryError();
  
  const fetchVideoData = async () => {
    try {
      if (!companyId) {
        throw new Error("Invalid company ID");
      }

      // Determinar qué columna usar basado en el tamaño
      const column = ["Phone", "Tablet"].includes(size) 
        ? "videopreview_phone" 
        : "videopreview";
      
      // Verificar primero si la compañía existe
      const { data: companyExists, error: existsError } = await supabase
        .from("company_overview")
        .select("id")
        .eq("id", companyId)
        .single();

      if (existsError || !companyExists) {
        throw new Error("Company not found");
      }

      // Obtener los datos del video
      const { data, error: videoError } = await supabase
        .from("company_overview")
        .select(`id, ${column}, cards!inner (card_color)`)
        .eq("id", companyId)
        .single();

      if (videoError) {
        throw videoError;
      }

      if (!data || !data[column]) {
        throw new Error("Video not found");
      }

      return {
        videoUrl: data[column],
        containerColor: data.cards?.[0]?.card_color || '#3A3A39'
      };

    } catch (error) {
      handleError(error);
      throw error;
    }
  };

  return useQuery({
    queryKey: queryKeys.videoPreview.byId(companyId, size),
    queryFn: fetchVideoData,
    staleTime: 1000 * 60 * 5, // 5 minutos
    cacheTime: 1000 * 60 * 30, // 30 minutos
    retry: 2,
    enabled: Boolean(companyId)
  });
}